module.exports = __webpack_public_path__ + "img/About_11.988ad411.png";